// Translations for EN/AR
export const translations = {
  en: {
    // Common
    admin: "Admin",
    back: "Back",
    continue: "Continue",
    submit: "Submit",
    ok: "OK",

    // Landing
    inviteOnly: "Invite Only — 2026",
    coBrand: "CREWZNATION · RIMAL CENTER · THE FAHRERS",
    inCollaboration: "in collaboration",
    heroLine1: "The",
    heroLine2: "Gathering",
    heroSub:
      "A Curated Assembly Of Exceptional Machines And Their Custodians. Entry Is By Application And Management Approval Only.",
    beginApplication: "Begin Application",
    footerLine: "Application Required · Limited Approved Vehicles",
    applyDeadline: "Registration is open",
    regClosedTitle: "Registration Is Open",
    regClosedBody: "Choose how you would like to register for §GATHERING§.",

    // Funnel intro
    appForEntry: "Application For Entry",
    introHeadL1: "A few questions",
    introHeadL2: "before you drive in",
    introSub:
      "Takes about 2 minutes. All applications are reviewed by CrewZNatioN, Rimal Center & The Fahrers management.",
    start: "Start",
    backLanding: "← Back",

    // Sections
    sectionApplicant: "APPLICANT",
    sectionVehicle: "VEHICLE",
    sectionUpload: "UPLOAD",
    sectionStandards: "STANDARDS",
    section: "Section",

    // Questions
    qFullName: "What is your full name?",
    qFullNamePh: "John Doe",
    qAge: "How old are you?",
    qAgePh: "25",
    ageMustBe18: "You must be at least 18 to apply.",
    ageInvalid: "Please enter a valid age between 18 and 99.",
    qMobile: "Your mobile number",
    qMobilePh: "+966 5X XXX XXXX",
    mobileInvalid: "Please enter a valid mobile number (e.g. +966 5X XXX XXXX or an international number with country code).",
    qEmail: "Your email address",
    qEmailPh: "you@example.com",
    emailInvalid: "Please enter a valid email address (e.g. you@example.com).",
    qInstagram: "Instagram username",
    qInstagramPh: "@yourhandle",
    qCountry: "Which country are you coming from?",
    qCountryPh: "Start typing your country…",
    qCity: "Which city are you coming from?",
    qCityPh: "City name (Arabic or English)",
    qOriginHelper: "Which country and city will you be coming from?",
    qGroup: "Which club do you represent?",
    qGroupPh: "Select your affiliation",
    qMake: "Vehicle make",
    qMakePh: "Porsche, Ferrari, Nissan...",
    qModel: "Vehicle model",
    qModelPh: "911 Turbo S, F8 Tributo, GT-R...",
    qYear: "Year",
    qYearPh: "2023",
    qColor: "Color",
    qColorPh: "Guards Red, Nero, Pearl White...",
    qPlate: "Plate number",
    qPlatePh: "ABC 1234",
    qMods: "Any modifications?",
    qModsPh: "Stock, Tuned ECU, Full exhaust, Wheels...",

    pressEnter: "press",
    enterKey: "Enter",
    requiredFieldErr: "This field is required",

    // Upload
    uploadHeadL1: "Show us your machine",
    uploadSub: "Upload clear, well-lit photos of your vehicle. JPG / PNG / WEBP / HEIC accepted (any size — we'll auto-resize). For best results, open this link in Safari, not Instagram's in-app browser.",
    primaryPhoto: "Primary Photo",
    secondPhoto: "Second Photo",
    frontPhoto: "Front View of the Vehicle",
    rearPhoto: "Rear View of the Vehicle",
    leftPhoto: "Left Side View of the Vehicle",
    rightPhoto: "Right Side View of the Vehicle",
    clickToUpload: "Click to upload",
    primaryRequired: "Primary vehicle photo is required",
    allPhotosRequired: "All four vehicle photos are required",
    photoUploaded: "Photo uploaded",
    uploadFailed: "Upload failed",
    fileTooLarge: "File too large (max 25 MB). Please use a smaller photo.",

    // Standards
    standardsHeadL1: "Rules & Regulations",
    standardsSub:
      "All information provided regarding your vehicle must be complete and accurate. All details will be thoroughly verified, and any incorrect or misleading information may result in immediate disqualification from participating in §GATHERING§.",
    vehicleInfoWarning: "",
    rule1: "Breaking any Saudi law, venue rules, or event management requirements will result in your immediate dismissal from §GATHERING§.",
    rule2: "I will not engage in reckless driving at or around the venue.",
    rule3: "I understand entry is by approval only — applications may be declined.",
    rule4: "I accept that the organizers' and management's decision is final.",
    rule5: "Any behavior that violates public order, public decency, or reflects negatively on Saudi society may result in immediate removal from §GATHERING§ and referral to the appropriate authorities.",
    rule6: "I confirm that all information and details provided regarding my vehicle are true and accurate. I understand that the information will be thoroughly verified and that incorrect information may result in disqualification from participating in §GATHERING§.",
    rule7: "I understand that participant vehicle entry is strictly between 4:00 PM and 6:00 PM on the assigned participation day. My vehicle must be parked and fully ready before 6:00 PM. Entry will not be permitted after 6:00 PM.",
    submitApplication: "Submit Application",
    submitting: "Submitting",
    agreeAllErr: "Please agree to all standards",
    submissionFailed: "Submission failed",

    // Thank you
    appReceived: "Application Received",
    thanksL1: "Thank you for",
    thanksL2: "applying",
    thanksSub:
      "Your application has been forwarded for review. Successful applicants will be contacted directly and will receive an official entry pass by email. The pass must be presented at the gate for entry.",
    eventDetails: "Event Details",
    evDate: "Date",
    evTime: "Time",
    evLocation: "Location",
    returnHome: "Return Home",

    // Event values
    evtDate: "Thursday–Saturday, December 10–12, 2026",
    evtTime: "6:00 PM – 1:00 AM",
    evtLocation: "Rimal Center, Riyadh",

    // Language toggle
    langEn: "EN",
    langAr: "العربية",

    // Shared event-date line — shown on every applicant step so no one
    // is ever unclear on when to come.
    eventDatesKicker: "EVENT DATES",
    eventDatesValue: "December 10–12, 2026",
    eventDatesLocation: "Rimal Center, Exit 17, Riyadh, Kingdom of Saudi Arabia",
    eventLocationKicker: "LOCATION",

    // Full Event Outdoor Display Pass (renamed from "Three-Day Outdoor Access")
    outdoorPassName: "Full Event Outdoor Display Pass",
    outdoorPassExplanation: "Valid for you and your car to participate on all three days of THE GATHERING — December 10–12, 2026.",

    // ---- Landing dual-path (Rev 7) ----
    chooseHowTitle: "How would you like to register?",
    vehicleCardTitle: "Register Your Vehicle",
    vehicleCardHelper: "For cars and motorcycles — participation is subject to application review and management approval.",
    vehicleCardCta: "Register Your Vehicle",
    visitorCardTitle: "Register as a Visitor",
    visitorCardHelper: "Free registration to attend the event.",
    visitorCardCta: "Register as a Visitor",

    // ---- Visitor form (Rev 7) ----
    visitorFormTitle: "Visitor Registration",
    visitorFormSubtitle: "The Gathering — Winter 2026 · December 10–12, 2026 · Rimal Center, Riyadh",
    visitorFreeNotice: "Free visitor registration.",
    visitorOneTicketNote: "One visitor ticket covers your entire group.",
    // Rev 7.6 (Feb 2026) neutral public group-ticket line + admin-only
    // draft prize-eligibility clause. The public line is shown large,
    // bold, above Submit. The prize-eligibility line stays hidden behind
    // VISITOR_PRIZE_DRAW_ENABLED and is rendered as an admin-only draft.
    visitorGroupTicketPublicEN: "One ticket covers your group. Only the person named on this registration is the ticket holder.",
    visitorGroupTicketPublicAR: "تذكرة واحدة تشمل مجموعتك. صاحب التذكرة هو الشخص المسجَّل باسمه فقط.",
    visitorPrizeEligibilityHeadingEN: "IMPORTANT",
    visitorPrizeEligibilityHeadingAR: "مهم",
    visitorPrizeEligibilityDraftEN: "IMPORTANT: One ticket covers your group. If it wins a prize, only the person named on this registration may claim it.",
    visitorPrizeEligibilityDraftAR: "مهم: تذكرة واحدة تشمل مجموعتك. وفي حال فوزها بجائزة، يحق لصاحب الاسم المسجّل فقط استلامها.",
    visitorEmailOptional: "optional",
    visitorEmailOptionalHelper: "If you leave email blank, we won't send a confirmation — copy or screenshot your visitor number on the next screen.",
    visitorPersonsSectionTitle: "Everyone attending",
    visitorPersonsSectionHelper: "For each attendee, we only need sex and age — no names, emails, or phone numbers for companions.",
    visitorPerson1WithYou: "Person {n} (You)",
    visitorPersonSex: "Sex",
    visitorPersonSexPh: "Select",
    visitorPersonAge: "Age",
    visitorSex_male: "Male",
    visitorSex_female: "Female",
    visitorErrPersonsCount: "Please complete details for every attendee.",
    visitorErrPersonsFields: "For each attendee, select sex and enter an age between 0 and 120.",
    visitorFullName: "Full name",
    visitorFullNamePh: "First and last name",
    visitorAgeBracket: "Age",
    visitorAgePlaceholder: "Select your age",
    visitorAge_under_18: "Under 18",
    visitorAge_18_24: "18–24",
    visitorAge_25_34: "25–34",
    visitorAge_35_44: "35–44",
    visitorAge_45_54: "45–54",
    visitorAge_55_plus: "55+",
    visitorAgeUnder18Notice: "Registration for under-18 visitors will open once a group policy is published. Please check back.",
    visitorGender: "Gender (optional)",
    visitorGender_male: "Male",
    visitorGender_female: "Female",
    visitorGender_prefer_not_to_say: "Prefer not to say",
    visitorGender_unspecified: "Not selected",
    visitorEmail: "Email address",
    visitorEmailPh: "you@example.com",
    visitorMobile: "Mobile number",
    visitorMobileHelper: "Please include your country code (e.g. +9665…).",
    visitorMobilePh: "+9665XXXXXXXX",
    visitorTotalAttending: "How many people will attend, including you?",
    visitorTotalAttendingHint: "Maximum 10 people, including you.",
    visitorGroupSectionTitle: "Ages of everyone attending",
    visitorGroupSectionHelper: "One registration number covers your group.",
    visitorPerson1: "Person 1 (you)",
    visitorPersonN: "Person {n}",
    visitorPersonAgePlaceholder: "Select age",
    visitorErrCompanionAge: "Please select an age for every person in your group.",
    visitorPlannedDays: "Which day(s) do you plan to attend?",
    visitorPlannedDaysHint: "Selecting a day does not reserve a ticket, and does not by itself grant entry on that day.",
    visitorDay_dec10: "Thursday · December 10, 2026",
    visitorDay_dec11: "Friday · December 11, 2026",
    visitorDay_dec12: "Saturday · December 12, 2026",
    visitorPrivacyLabel: "Privacy notice",
    // Feb 2026 owner-approved bilingual Visitor Prize Draw NOTICE
    // (informational — NOT consent; distinct from the dormant
    // VISITOR_PRIZE_DRAW_ENABLED consent flow which stays gated off).
    visitorPrizeNoticeHeadingEN: "VISITOR PRIZES",
    visitorPrizeNoticeBodyEN: "Each completed visitor registration receives one chance to win. Added family members do not receive separate chances. The prize draw and winner announcement will take place on Saturday, December 12, 2026—the final day of THE GATHERING. Further details will be announced later.",
    visitorPrizeNoticeHeadingAR: "جوائز الزوار",
    visitorPrizeNoticeBodyAR: "يحصل كل تسجيل مكتمل للزوار على فرصة واحدة للفوز، ولا يحصل أفراد العائلة المضافون على فرص مستقلة. سيُجرى السحب على الجوائز ويُعلن عن الفائزين يوم السبت ١٢ ديسمبر ٢٠٢٦، في اليوم الختامي لفعالية THE GATHERING. وستُعلن التفاصيل لاحقًا.",
    visitorPrivacyText: "Your details are stored securely by CrewZNatioN for this event only, including using any assistance answer to prepare arrangements on site. They are not sold or shared. You can request deletion at any time by contacting the organizer. A requested arrangement is a preference, not a guarantee — our team will confirm what we can offer after review.",
    visitorPrivacyAccept: "I have read and understood the privacy notice.",
    visitorMarketingConsent: "Optional: I'd like to receive future event updates from CrewZNatioN. (You can unsubscribe anytime.)",
    // Rev 7.8 — optional bilingual assistance question. Never printed
    // on ticket, never in general notification emails.
    visitorAssistanceTitle: "Do you or anyone attending with you need accessibility arrangements related to a disability or any other assistance during the event?",
    visitorAssistanceHelper: "Sharing this is optional. Your lead mobile is used for arrangements — no diagnosis or documentation is collected.",
    visitorAssistanceAnswer_no: "No",
    visitorAssistanceAnswer_yes: "Yes",
    visitorAssistanceAnswer_prefer_not_to_say: "Prefer not to say",
    visitorAssistanceNeedsTitle: "What would help? (tick any that apply — all optional)",
    visitorAssistanceNeed_mobility: "Mobility or wheelchair access",
    visitorAssistanceNeed_hearing: "Hearing assistance",
    visitorAssistanceNeed_visual: "Visual assistance",
    visitorAssistanceNeed_other: "Other assistance",
    visitorAssistanceNote: "Tell us what would help (optional)",
    visitorAssistanceNotePh: "A short note is enough — we'll follow up on the mobile you provided.",
    visitorAssistanceGuaranteeNotice: "A requested arrangement is a preference, not a guarantee — our team will confirm after review.",
    visitorSubmit: "Register",
    visitorSubmitting: "Registering…",
    visitorErrRequired: "This field is required.",
    visitorErrEmail: "Please enter a valid email address.",
    visitorErrEmailRequired: "Please enter a valid email address (required).",
    visitorErrLeadSex: "Please select your gender.",
    visitorErrLeadAge: "Please enter your age (0–120).",
    visitorErrCity: "Please enter your city.",
    visitorErrCountry: "Please choose your country.",
    visitorErrFamilyFields: "If you fill a family row, sex must be male/female and age must be 0–120.",
    // Feb 2026 owner directive — every added family member MUST supply
    // gender AND age. Applied per-row with the same required treatment
    // as the lead fields; legacy stored rows are unaffected.
    visitorErrFamilySex: "Please select this family member's gender.",
    visitorErrFamilyAge: "Please enter this family member's age.",
    visitorErrMaxGroup: "Groups are capped at 10 people (you plus up to 9 family members).",
    visitorErrTicketAck: "Please tick the group-ticket acknowledgment to continue.",
    visitorTagRequired: "Required",
    visitorTagOptional: "Optional",
    visitorLeadSectionTitle: "Your details",
    visitorLeadAge: "Your age",
    visitorLeadSex: "Gender",
    visitorCity: "City",
    visitorCityPh: "e.g. Riyadh, Jeddah, Cairo…",
    visitorCountry: "Country",
    visitorCountryPh: "Select your country",
    visitorCountrySearchPh: "Search country / بحث…",
    visitorFamilySectionTitle: "Family members",
    visitorFamilySectionHelper: "Add up to 9 family members. Sex and age are optional for each.",
    visitorFamilyAdd: "+ Add family member",
    visitorFamilyRemove: "Remove",
    visitorFamilyRowLabel: "Person {n}",
    visitorFamilyMaxHint: "Groups are capped at 10 people.",
    visitorAnsweringOptional: "Answering is optional.",
    visitorPickOne: "You may select one answer.",
    visitorInterestExperienceTitle: "What are you most excited to experience at THE GATHERING?",
    visitorInterestVehiclesTitle: "Which vehicles interest you most?",
    visitorInterestPickUpTo2: "You may select as many as apply · {n} selected",
    visitorIExp_vehicle_displays: "Vehicle displays",
    visitorIExp_sim_racing: "Sim racing",
    visitorIExp_community_meet: "Meeting owners and the car community",
    visitorIExp_no_preference: "No specific preference",
    visitorIVeh_classic: "Classic cars",
    visitorIVeh_modified_jdm: "Modified / JDM cars",
    visitorIVeh_supercars: "Supercars",
    visitorIVeh_motorcycles: "Motorcycles",
    visitorIVeh_no_preference: "No specific preference",
    visitorBudgetPurchaseTitle: "If you were considering purchasing a vehicle within the next 12 months, what budget range would you most likely consider?",
    visitorBudP_le_150k: "SAR 150,000 or less",
    visitorBudP_150k_300k: "SAR 150,001–300,000",
    visitorBudP_300k_500k: "SAR 300,001–500,000",
    visitorBudP_gt_500k: "More than SAR 500,000",
    visitorBudP_not_considering: "Not currently considering purchasing a vehicle",
    visitorBudP_prefer_not_to_say: "Prefer not to say",
    visitorBudgetModTitle: "If you were considering modifying or upgrading a vehicle within the next 12 months, what total budget would you most likely allocate?",
    visitorBudM_le_25k: "SAR 25,000 or less",
    visitorBudM_25k_50k: "SAR 25,001–50,000",
    visitorBudM_50k_100k: "SAR 50,001–100,000",
    visitorBudM_gt_100k: "More than SAR 100,000",
    visitorBudM_not_considering: "Not currently considering modifications",
    visitorBudM_prefer_not_to_say: "Prefer not to say",
    visitorTicketAckEN: "One ticket covers you and any family members you added. It is issued in your name.",
    visitorTicketAckAR: "تذكرة واحدة تشملك وتشمل أفراد العائلة الذين أضفتهم، وتصدر باسمك.",
    visitorTicketAckCheckEN: "I understand one ticket covers me and any family members I added; the ticket is issued in my name.",
    visitorTicketAckCheckAR: "أفهم أن تذكرة واحدة تشملني وتشمل أفراد العائلة الذين أضفتهم، وتصدر باسمي.",
    visitorAssistanceTitle: "Do you or anyone attending with you need accessibility arrangements related to a disability or any other assistance during the event?",
    visitorErrMobile: "Please include country code (e.g. +9665…).",
    visitorErrAge: "Please select your age.",
    visitorErrTotalMin: "Total attending must be at least 1.",
    visitorErrTotalMax: "Total attending cannot exceed 10.",
    visitorErrPrivacy: "Please accept the privacy notice to continue.",
    visitorErrPrizeConsent: "Please tick the prize-claim acknowledgment to continue.",

    // ---- Draft prize-draw copy (Rev 7, admin-only preview) ----
    // These strings are NOT public. They render only inside the admin
    // dashboard's clearly-labeled "Draft prize-draw copy" preview panel
    // and are gated by the `visitor_prize_draw_enabled` backend flag
    // (default false). Do not surface any of these strings in the
    // public visitor form or landing until eligibility, prizes,
    // odds/entry mechanics, check-in cutoff, draw time, winner contact,
    // licence/authority and exact terms are approved and disclosed.
    drawDraftBadge: "Draft · not public · admin preview only",
    drawDraftMechanic: "One verified physical check-in per visitor reference per day. Planned-day selection alone does not count — a staff-confirmed on-site check-in is required. Maximum three chances across December 10, 11, 12. Group size does not add chances — every additional person must register separately. Winners will be announced on Saturday, December 12, 2026.",
    drawDraftLegalGate: "Do NOT publish until: prize list finalised, terms & eligibility approved, and any required Saudi Ministry of Commerce commercial-competition permit obtained (mc.gov.sa/ar/mediacenter/News/Pages/21-09-25-01.aspx, /10-09-24-01.aspx).",
    drawDraftBlurb: "Keep your visitor number. Each day you attend and check in gives your number one more entry in the prize draw, up to three. Winners will be announced on Saturday, December 12.",
    drawDraftFormNote: "Draft copy for the registration form (do not publish): Show up on any of December 10–12 and let staff scan you in to earn a chance in the daily-attendance prize. One chance per day, up to three across the event. Full terms will be published before the event.",
    drawDraftConfirmationNote: "Draft copy for the confirmation email (do not publish): We'll count your visits day by day. Attending on more days gives you more chances in the daily-attendance prize. Group registration keeps one number — additional people can register on their own if they want their own chances.",
    drawDraftReminderNote: "Draft copy for a single pre-event reminder — PROPOSED, not scheduled. Owner has not authorised send; email delivery is not yet audited. Suggested body: 'The gathering starts tomorrow. Every day you attend and staff confirm your check-in adds one more chance in the prize draw, up to three. Winners are announced on Saturday, December 12.'",
    drawDraftDaysHelper: "Your selection helps us plan. You receive an additional draw entry only for each day you attend and check in at the venue.",
    drawDraftRuleset: "Day 1 visitors remain eligible for the final draw even without Day 3 attendance. Group size does not grant entries for unnamed companions. Maximum one entry per verified person per day. Three-day visitor maximum: three entries. Prize details and draw terms must be disclosed beforehand and licence confirmed.",
    // Rev 7.6 owner-approved draft eligibility clause. Admin preview
    // only; DO NOT publish until VISITOR_PRIZE_DRAW_ENABLED=true and
    // legal terms/permit are approved.
    drawDraftEligibilityEN: "Ticket-level entry only. The lead registrant (name + mobile on file) is the sole prize claimant. Accompanying persons do not receive individual tickets, draw entries, or independent prize claims. At most one verified check-in entry per group ticket per day, up to three across December 10–12.",
    drawDraftEligibilityAR: "المشاركة على مستوى التذكرة فقط. صاحب التذكرة (الاسم والجوّال المسجَّلان) هو الوحيد المخوَّل باستلام الجائزة. لا يحصل المرافقون على تذاكر أو فرص أو مطالبات مستقلة. الحد الأقصى تسجيل حضور مؤكَّد واحد لكل تذكرة مجموعة في اليوم، وبحدٍ أقصى ثلاث فرص خلال ١٠–١٢ ديسمبر.",

    // ---- Visitor confirmation (Rev 7) ----
    visitorTyTitle: "You're registered.",
    visitorTyRefLabel: "Your visitor reference",
    visitorTyRefHelper: "Keep your visitor number. Staff may ask for it on arrival.",
    visitorTyCopy: "Copy visitor number",
    visitorTyCopied: "Copied",
    visitorTyCopyFailed: "Couldn't copy — please long-press the number instead.",
    visitorTyEmailReassure: "Copy or screenshot your visitor number and keep it handy for arrival.",
    visitorTyBody: "Thank you for registering as a visitor for THE GATHERING — Winter 2026. Save your visitor reference below — it is your group's only ticket record.",
    visitorTyDupNote: "You're already registered under this reference — we won't create a duplicate.",
    visitorTyHome: "Back to home",

    // ---- Admin visitor panel (Rev 7) ----
    adminVisitorsTitle: "Visitor Registrations",
    adminVisitorsSearch: "Search by reference, name, email, or mobile",
    adminVisitorsDayAll: "All days",
    adminVisitorsRegistrations: "Registrations",
    adminVisitorsPlannedHead: "Planned headcount (all groups)",
    adminVisitorsPlannedByDay: "Planned by day",
    adminVisitorsVerifiedByDay: "Verified on-site by day",
    adminVisitorsExportCsv: "Export CSV",
    adminVisitorsCheckinDec10: "Check in · Dec 10",
    adminVisitorsCheckinDec11: "Check in · Dec 11",
    adminVisitorsCheckinDec12: "Check in · Dec 12",
    adminVisitorsCheckedIn: "Checked in",
    adminVisitorsCheckinConfirm: "Confirm on-site check-in for {name} on {day}? This cannot be undone from the UI.",
    adminVisitorsNoRows: "No visitor registrations match this filter yet.",
  },
  ar: {
    admin: "الإدارة",
    back: "رجوع",
    continue: "التالي",
    submit: "إرسال",
    ok: "التالي",

    inviteOnly: "بدعوة خاصة — ٢٠٢٦",
    coBrand: "CREWZNATION · RIMAL CENTER · THE FAHRERS",
    inCollaboration: "بالتعاون مع",
    heroLine1: "The",
    heroLine2: "Gathering",
    heroSub:
      "تجمّع مُنتقى يضم آلاتٍ استثنائية وأصحابها. الدخول بالتقديم والموافقة من الإدارة فقط.",
    beginApplication: "ابدأ التقديم",
    footerLine: "التقديم إلزامي • عدد المركبات محدود • المشاركة بعد مراجعة الطلب وموافقة الإدارة",
    applyDeadline: "التسجيل مفتوح",
    regClosedTitle: "التسجيل مفتوح",
    regClosedBody: "اختر طريقة تسجيلك في §GATHERING§.",

    appForEntry: "طلب الدخول",
    introHeadL1: "بعض الأسئلة",
    introHeadL2: "قبل أن تنضم إلينا",
    introSub:
      "تستغرق حوالي دقيقتين. تتم مراجعة جميع الطلبات من قبل إدارة CrewZNatioN و Rimal Center و The Fahrers.",
    start: "ابدأ",
    backLanding: "→ رجوع",

    sectionApplicant: "مقدم الطلب",
    sectionVehicle: "المركبة",
    sectionUpload: "الصور",
    sectionStandards: "المعايير",
    section: "القسم",

    qFullName: "ما هو اسمك الكامل؟",
    qFullNamePh: "الاسم الكامل",
    qAge: "كم عمرك؟",
    qAgePh: "٢٥",
    ageMustBe18: "يجب أن يكون عمرك 18 سنة أو أكثر للتقديم.",
    ageInvalid: "الرجاء إدخال عمر صحيح بين 18 و 99.",
    qMobile: "رقم جوالك",
    qMobilePh: "+٩٦٦ ٥X XXX XXXX",
    mobileInvalid: "الرجاء إدخال رقم جوال صحيح مع مفتاح الدولة (مثال: +966 5X XXX XXXX).",
    qEmail: "بريدك الإلكتروني",
    qEmailPh: "you@example.com",
    emailInvalid: "الرجاء إدخال بريد إلكتروني صحيح (مثال: you@example.com).",
    qInstagram: "اسم حساب الإنستغرام",
    qInstagramPh: "@yourhandle",
    qCountry: "من أي دولة ستأتي للمشاركة؟",
    qCountryPh: "ابدأ بكتابة اسم الدولة…",
    qCity: "من أي مدينة ستأتي للمشاركة؟",
    qCityPh: "اسم المدينة (بالعربية أو الإنجليزية)",
    qOriginHelper: "من أي دولة ومدينة بتجي للمشاركة؟",
    qGroup: "ما النادي الذي تُمثّله؟",
    qGroupPh: "اختر انتماءك",
    qMake: "ماركة المركبة",
    qMakePh: "بورش، فيراري، نيسان...",
    qModel: "موديل المركبة",
    qModelPh: "٩١١ توربو، F8 تريبوتو، GT-R...",
    qYear: "السنة",
    qYearPh: "٢٠٢٣",
    qColor: "اللون",
    qColorPh: "أحمر، أسود، أبيض لؤلؤي...",
    qPlate: "رقم اللوحة",
    qPlatePh: "أ ب ج ١٢٣٤",
    qMods: "هل توجد تعديلات؟",
    qModsPh: "ستوك، برمجة، عوادم، جنوط...",

    pressEnter: "اضغط",
    enterKey: "Enter",
    requiredFieldErr: "هذا الحقل مطلوب",

    uploadHeadL1: "أرنا آلتك",
    uploadSub: "ارفع صورًا واضحة ومضاءة جيدًا لمركبتك. تُقبل صيغ JPG / PNG / WEBP / HEIC (أي حجم — سنقوم بتصغيرها تلقائياً). للحصول على أفضل النتائج، افتح هذا الرابط في Safari وليس متصفح Instagram الداخلي.",
    primaryPhoto: "الصورة الرئيسية",
    secondPhoto: "الصورة الثانية",
    frontPhoto: "صورة أمامية للمركبة",
    rearPhoto: "صورة خلفية للمركبة",
    leftPhoto: "صورة من الجهة اليسرى للمركبة",
    rightPhoto: "صورة من الجهة اليمنى للمركبة",
    clickToUpload: "اضغط للرفع",
    primaryRequired: "الصورة الرئيسية للمركبة مطلوبة",
    allPhotosRequired: "جميع الصور الأربع للمركبة مطلوبة",
    photoUploaded: "تم رفع الصورة",
    uploadFailed: "فشل الرفع",
    fileTooLarge: "الملف كبير جداً (الحد الأقصى ٢٥ ميجابايت). يُرجى استخدام صورة أصغر.",

    standardsHeadL1: "القواعد واللوائح",
    standardsSub: "يجب أن تكون جميع المعلومات المقدمة بشأن مركبتك كاملة وصحيحة، حيث ستخضع جميع التفاصيل للتحقق بشكل دقيق، وأي معلومات غير صحيحة أو مضللة قد تؤدي إلى استبعاد طلبك فورًا من المشاركة في §GATHERING§.",
    vehicleInfoWarning: "",
    rule1: "قد يؤدي مخالفة أي من الأنظمة السعودية أو قواعد الموقع أو متطلبات إدارة الفعالية إلى استبعادك فورًا من §GATHERING§.",
    rule2: "أتعهد بعدم القيادة المتهورة داخل الموقع أو في محيطه.",
    rule3: "أفهم أن الدخول يتم بالموافقة فقط، وقد يتم رفض الطلب.",
    rule4: "أقر بأن قرار المنظمين والإدارة نهائي.",
    rule5: "أي سلوك يخالف النظام العام أو الآداب العامة أو ينعكس بصورة سلبية على المجتمع السعودي قد يؤدي إلى الاستبعاد الفوري من §GATHERING§ وإحالته إلى الجهات المختصة.",
    rule6: "أؤكد أن جميع المعلومات والتفاصيل التي قدمتها بشأن مركبتي صحيحة ودقيقة، وأدرك أن المعلومات ستخضع للتحقق بشكل دقيق، وأن أي معلومات غير صحيحة قد تؤدي إلى استبعاد طلبي من المشاركة في §GATHERING§.",
    rule7: "أقر بأن دخول مركبات المشاركين يكون حصريًا من الساعة 4:00 مساءً حتى الساعة 6:00 مساءً في يوم المشاركة المحدد لي، ويجب أن تكون مركبتي متوقفة وجاهزة بالكامل قبل الساعة 6:00 مساءً. ولن يُسمح بالدخول بعد الساعة 6:00 مساءً.",
    submitApplication: "إرسال الطلب",
    submitting: "جارٍ الإرسال",
    agreeAllErr: "يرجى الموافقة على جميع المعايير",
    submissionFailed: "فشل الإرسال",

    appReceived: "تم استلام الطلب",
    thanksL1: "شكراً",
    thanksL2: "لتقديمك",
    thanksSub:
      "تم إرسال طلبك للمراجعة. سيتم التواصل مباشرة مع المتقدمين المقبولين، وسيتم إرسال تصريح الدخول الرسمي عبر البريد الإلكتروني. يجب إبراز التصريح عند البوابة للدخول.",
    eventDetails: "تفاصيل الفعالية",
    evDate: "التاريخ",
    evTime: "الوقت",
    evLocation: "الموقع",
    returnHome: "العودة للرئيسية",

    evtDate: "الخميس - السبت، ديسمبر ١٠ - ١٢ • ٢٠٢٦",
    evtTime: "٦ مساءً - ١ صباحاً",
    evtLocation: "رمال سنتر، الرياض",

    langEn: "EN",
    langAr: "العربية",

    // Shared event-date line — shown on every applicant step.
    eventDatesKicker: "تاريخ الفعالية",
    eventDatesValue: "١٠–١٢ ديسمبر ٢٠٢٦",
    eventDatesLocation: "الرمال سنتر، مخرج ١٧، الرياض، المملكة العربية السعودية",
    eventLocationKicker: "الموقع",

    // Full Event Outdoor Display Pass (renamed).
    outdoorPassName: "تصريح عرض السيارة في الساحة الخارجية طوال أيام الفعالية",
    outdoorPassExplanation: "يتيح لك هذا التصريح المشاركة بسيارتك في الأيام الثلاثة لفعالية THE GATHERING — من ١٠ إلى ١٢ ديسمبر ٢٠٢٦.",

    // ---- Landing dual-path (Rev 7) — AR ----
    chooseHowTitle: "كيف ترغب بالتسجيل؟",
    vehicleCardTitle: "سجّل مركبتك",
    vehicleCardHelper: "للسيارات والدراجات النارية — المشاركة بعد مراجعة الطلب وموافقة الإدارة.",
    vehicleCardCta: "سجّل مركبتك",
    visitorCardTitle: "سجّل كزائر",
    visitorCardHelper: "تسجيل مجاني لحضور الفعالية.",
    visitorCardCta: "سجّل كزائر",

    // ---- Visitor form — AR ----
    visitorFormTitle: "تسجيل الزوار",
    visitorFormSubtitle: "THE GATHERING · ١٠–١٢ ديسمبر ٢٠٢٦ · الرمال سنتر، مخرج ١٧، الرياض، المملكة العربية السعودية",
    visitorFreeNotice: "التسجيل للزوار مجانًا.",
    visitorOneTicketNote: "تذكرة زائر واحدة تشمل مجموعتك كاملة.",
    // Rev 7.6 group-ticket public + admin-only prize-eligibility draft
    visitorGroupTicketPublicEN: "One ticket covers your group. Only the person named on this registration is the ticket holder.",
    visitorGroupTicketPublicAR: "تذكرة واحدة تشمل مجموعتك. صاحب التذكرة هو الشخص المسجَّل باسمه فقط.",
    visitorPrizeEligibilityHeadingEN: "IMPORTANT",
    visitorPrizeEligibilityHeadingAR: "مهم",
    visitorPrizeEligibilityDraftEN: "IMPORTANT: One ticket covers your group. If it wins a prize, only the person named on this registration may claim it.",
    visitorPrizeEligibilityDraftAR: "مهم: تذكرة واحدة تشمل مجموعتك. وفي حال فوزها بجائزة، يحق لصاحب الاسم المسجّل فقط استلامها.",
    visitorEmailOptional: "اختياري",
    visitorEmailOptionalHelper: "إن تركت البريد فارغًا فلن نرسل تأكيدًا — انسخ رقم زائرك أو التقط له لقطة شاشة في الشاشة التالية.",
    visitorPersonsSectionTitle: "جميع الحاضرين",
    visitorPersonsSectionHelper: "لكل حاضر نحتاج فقط الجنس والعمر — لا أسماء ولا بريد ولا هواتف للمرافقين.",
    visitorPerson1WithYou: "الشخص {n} (أنت)",
    visitorPersonSex: "الجنس",
    visitorPersonSexPh: "اختر",
    visitorPersonAge: "العمر",
    visitorSex_male: "ذكر",
    visitorSex_female: "أنثى",
    visitorErrPersonsCount: "يُرجى إكمال بيانات جميع الحاضرين.",
    visitorErrPersonsFields: "لكل حاضر: اختر الجنس وأدخل عمرًا بين ٠ و١٢٠.",
    visitorFullName: "الاسم الكامل",
    visitorFullNamePh: "الاسم الأول والاسم الأخير",
    visitorAgeBracket: "العمر",
    visitorAgePlaceholder: "اختر عمرك",
    visitorAge_under_18: "أقل من ١٨",
    visitorAge_18_24: "١٨–٢٤",
    visitorAge_25_34: "٢٥–٣٤",
    visitorAge_35_44: "٣٥–٤٤",
    visitorAge_45_54: "٤٥–٥٤",
    visitorAge_55_plus: "٥٥+",
    visitorAgeUnder18Notice: "تسجيل الزوار دون سن ١٨ سيُتاح لاحقًا عند اعتماد سياسة المجموعات. يُرجى المراجعة لاحقًا.",
    visitorGender: "الجنس (اختياري)",
    visitorGender_male: "ذكر",
    visitorGender_female: "أنثى",
    visitorGender_prefer_not_to_say: "أفضّل عدم الإفصاح",
    visitorGender_unspecified: "لم يُختَر",
    visitorEmail: "البريد الإلكتروني",
    visitorEmailPh: "you@example.com",
    visitorMobile: "رقم الجوال",
    visitorMobileHelper: "يُرجى تضمين رمز الدولة (مثال: ‎+9665…).",
    visitorMobilePh: "+9665XXXXXXXX",
    visitorTotalAttending: "كم شخصًا سيحضر، بمن فيهم أنت؟",
    visitorTotalAttendingHint: "الحد الأقصى ١٠ أشخاص، بمن فيهم أنت.",
    visitorGroupSectionTitle: "أعمار جميع الحاضرين",
    visitorGroupSectionHelper: "رقم تسجيل واحد يشمل مجموعتك.",
    visitorPerson1: "الشخص ١ (أنت)",
    visitorPersonN: "الشخص {n}",
    visitorPersonAgePlaceholder: "اختر العمر",
    visitorErrCompanionAge: "يُرجى اختيار عمر لكل شخص في مجموعتك.",
    visitorPlannedDays: "في أي يوم تنوي الحضور؟",
    visitorPlannedDaysHint: "اختيارك ليوم لا يحجز تذكرة، ولا يمنح دخولًا مؤكدًا في ذلك اليوم.",
    visitorDay_dec10: "الخميس · ١٠ ديسمبر ٢٠٢٦",
    visitorDay_dec11: "الجمعة · ١١ ديسمبر ٢٠٢٦",
    visitorDay_dec12: "السبت · ١٢ ديسمبر ٢٠٢٦",
    visitorPrivacyLabel: "إشعار الخصوصية",
    // AR mirrors of the bilingual Visitor Prize Draw NOTICE (keys are
    // repeated in both locale blocks so t() resolves correctly under
    // either language toggle).
    visitorPrizeNoticeHeadingEN: "VISITOR PRIZES",
    visitorPrizeNoticeBodyEN: "Each completed visitor registration receives one chance to win. Added family members do not receive separate chances. The prize draw and winner announcement will take place on Saturday, December 12, 2026—the final day of THE GATHERING. Further details will be announced later.",
    visitorPrizeNoticeHeadingAR: "جوائز الزوار",
    visitorPrizeNoticeBodyAR: "يحصل كل تسجيل مكتمل للزوار على فرصة واحدة للفوز، ولا يحصل أفراد العائلة المضافون على فرص مستقلة. سيُجرى السحب على الجوائز ويُعلن عن الفائزين يوم السبت ١٢ ديسمبر ٢٠٢٦، في اليوم الختامي لفعالية THE GATHERING. وستُعلن التفاصيل لاحقًا.",
    visitorPrivacyText: "تُخزَّن بياناتك بأمان لدى CrewZNatioN لهذه الفعالية فقط، ويشمل ذلك استخدام أي إجابة عن المساعدة لتهيئة الترتيبات في الموقع. لا تُباع ولا تُشارَك. يمكنك طلب حذفها في أي وقت بالتواصل مع المنظِّم. أي ترتيب مطلوب يُعدّ رغبة وليس ضمانًا — سيؤكد فريقنا ما يمكن توفيره بعد المراجعة.",
    visitorPrivacyAccept: "قرأتُ إشعار الخصوصية ووافقت عليه.",
    visitorMarketingConsent: "اختياري: أرغب في تلقّي تحديثات الفعاليات المستقبلية من CrewZNatioN. (يمكنك إلغاء الاشتراك في أي وقت.)",
    // Rev 7.8 — bilingual assistance question strings (AR)
    visitorAssistanceTitle: "هل تحتاج أنت أو أحد مرافقيك إلى ترتيبات ميسّرة بسبب إعاقة أو إلى مساعدة إضافية أثناء الفعالية؟",
    visitorAssistanceHelper: "المشاركة اختيارية. سنستخدم رقم جوّالك المسجَّل للترتيبات — لا نطلب تشخيصًا ولا وثائق طبية.",
    visitorAssistanceAnswer_no: "لا",
    visitorAssistanceAnswer_yes: "نعم",
    visitorAssistanceAnswer_prefer_not_to_say: "أفضّل عدم الإفصاح",
    visitorAssistanceNeedsTitle: "ما الذي يساعدك؟ (اختر ما يلزم — جميعها اختيارية)",
    visitorAssistanceNeed_mobility: "مساعدة في التنقل أو استخدام كرسي متحرك",
    visitorAssistanceNeed_hearing: "مساعدة تتعلق بالسمع",
    visitorAssistanceNeed_visual: "مساعدة تتعلق بالبصر",
    visitorAssistanceNeed_other: "مساعدة أخرى",
    visitorAssistanceNote: "أخبرنا بما يساعدك (اختياري)",
    visitorAssistanceNotePh: "سطر قصير يكفي — سنتواصل عبر رقم الجوّال الذي زوّدتنا به.",
    visitorAssistanceGuaranteeNotice: "أي ترتيب مطلوب يُعدّ رغبة وليس ضمانًا — سيؤكد فريقنا ذلك بعد المراجعة.",
    visitorSubmit: "سجّل",
    visitorSubmitting: "جارٍ التسجيل…",
    visitorErrRequired: "هذا الحقل مطلوب.",
    visitorErrEmail: "يُرجى إدخال بريد إلكتروني صحيح.",
    visitorErrEmailRequired: "يُرجى إدخال بريد إلكتروني صحيح (مطلوب).",
    visitorErrLeadSex: "يرجى تحديد الجنس.",
    visitorErrLeadAge: "يُرجى إدخال عمرك (٠–١٢٠).",
    visitorErrCity: "يُرجى إدخال المدينة.",
    visitorErrCountry: "يُرجى اختيار الدولة.",
    visitorErrFamilyFields: "إذا عبّأت صف فرد من العائلة، فيجب أن يكون الجنس ذكر/أنثى والعمر ٠–١٢٠.",
    visitorErrFamilySex: "يرجى تحديد جنس فرد العائلة.",
    visitorErrFamilyAge: "يرجى إدخال عمر فرد العائلة.",
    visitorErrMaxGroup: "يُسمح بحد أقصى ١٠ أشخاص لكل مجموعة (أنت + حتى ٩ من أفراد العائلة).",
    visitorErrTicketAck: "يُرجى وضع علامة الإقرار بتذكرة المجموعة للمتابعة.",
    visitorTagRequired: "مطلوب",
    visitorTagOptional: "اختياري",
    visitorLeadSectionTitle: "بياناتك",
    visitorLeadAge: "عمرك",
    visitorLeadSex: "الجنس",
    visitorCity: "المدينة",
    visitorCityPh: "مثال: الرياض، جدة، القاهرة…",
    visitorCountry: "الدولة",
    visitorCountryPh: "اختر دولتك",
    visitorCountrySearchPh: "ابحث عن دولة / Search…",
    visitorFamilySectionTitle: "أفراد العائلة",
    visitorFamilySectionHelper: "أضف حتى ٩ من أفراد العائلة. الجنس والعمر اختياريان لكل فرد.",
    visitorFamilyAdd: "+ إضافة فرد من العائلة",
    visitorFamilyRemove: "إزالة",
    visitorFamilyRowLabel: "الشخص {n}",
    visitorFamilyMaxHint: "الحد الأقصى للمجموعة هو ١٠ أشخاص.",
    visitorAnsweringOptional: "الإجابة اختيارية.",
    visitorPickOne: "يمكنك تحديد إجابة واحدة.",
    visitorInterestExperienceTitle: "ما أكثر ما تتطلع إلى تجربته في THE GATHERING؟",
    visitorInterestVehiclesTitle: "ما فئات المركبات التي تهمك أكثر؟",
    visitorInterestPickUpTo2: "يمكنك اختيار ما ينطبق · تم اختيار {n}",
    visitorIExp_vehicle_displays: "عروض المركبات",
    visitorIExp_sim_racing: "سباقات المحاكاة",
    visitorIExp_community_meet: "لقاء ملاك المركبات ومجتمع السيارات",
    visitorIExp_no_preference: "ليس لدي تفضيل محدد",
    visitorIVeh_classic: "السيارات الكلاسيكية",
    visitorIVeh_modified_jdm: "السيارات المعدّلة / سيارات JDM",
    visitorIVeh_supercars: "السيارات الخارقة",
    visitorIVeh_motorcycles: "الدراجات النارية",
    visitorIVeh_no_preference: "ليس لدي تفضيل محدد",
    visitorBudgetPurchaseTitle: "إذا كنت تفكر في شراء مركبة خلال الأشهر الـ١٢ القادمة، فما النطاق السعري الأقرب إلى ميزانيتك؟",
    visitorBudP_le_150k: "١٥٠٬٠٠٠ ريال أو أقل",
    visitorBudP_150k_300k: "من ١٥٠٬٠٠١ إلى ٣٠٠٬٠٠٠ ريال",
    visitorBudP_300k_500k: "من ٣٠٠٬٠٠١ إلى ٥٠٠٬٠٠٠ ريال",
    visitorBudP_gt_500k: "أكثر من ٥٠٠٬٠٠٠ ريال",
    visitorBudP_not_considering: "لا أفكر حاليًا في شراء مركبة",
    visitorBudP_prefer_not_to_say: "أفضل عدم الإجابة",
    visitorBudgetModTitle: "إذا كنت تفكر في تعديل مركبة أو تطويرها خلال الأشهر الـ١٢ القادمة، فما إجمالي الميزانية التي يُرجّح أن تخصصها لذلك؟",
    visitorBudM_le_25k: "٢٥٬٠٠٠ ريال أو أقل",
    visitorBudM_25k_50k: "من ٢٥٬٠٠١ إلى ٥٠٬٠٠٠ ريال",
    visitorBudM_50k_100k: "من ٥٠٬٠٠١ إلى ١٠٠٬٠٠٠ ريال",
    visitorBudM_gt_100k: "أكثر من ١٠٠٬٠٠٠ ريال",
    visitorBudM_not_considering: "لا أفكر حاليًا في تعديل مركبة أو تطويرها",
    visitorBudM_prefer_not_to_say: "أفضل عدم الإجابة",
    visitorTicketAckEN: "One ticket covers you and any family members you added. It is issued in your name.",
    visitorTicketAckAR: "تذكرة واحدة تشملك وتشمل أفراد العائلة الذين أضفتهم، وتصدر باسمك.",
    visitorTicketAckCheckEN: "I understand one ticket covers me and any family members I added; the ticket is issued in my name.",
    visitorTicketAckCheckAR: "أفهم أن تذكرة واحدة تشملني وتشمل أفراد العائلة الذين أضفتهم، وتصدر باسمي.",
    visitorAssistanceTitle: "هل تحتاج أنت أو أحد مرافقيك إلى ترتيبات ميسّرة بسبب إعاقة أو إلى مساعدة إضافية أثناء الفعالية؟",
    visitorErrMobile: "يُرجى تضمين رمز الدولة (مثال: ‎+9665…).",
    visitorErrAge: "يُرجى اختيار عمرك.",
    visitorErrTotalMin: "يجب أن يكون عدد الحضور شخصًا واحدًا على الأقل.",
    visitorErrTotalMax: "لا يمكن أن يتجاوز عدد الحضور ١٠.",
    visitorErrPrivacy: "يُرجى قبول إشعار الخصوصية للمتابعة.",
    visitorErrPrizeConsent: "يُرجى وضع علامة الإقرار بشرط استلام الجائزة للمتابعة.",

    // ---- Draft prize-draw copy — AR (admin-only preview) ----
    drawDraftBadge: "مسوّدة · غير عامة · معاينة الإدارة فقط",
    drawDraftMechanic: "تسجيل حضور فعلي واحد مؤكَّد من الطاقم لكل رقم زائر في اليوم الواحد. اختيار يوم الحضور مسبقًا لا يُحتسب — يشترط تأكيد الحضور الفعلي على أرض الموقع. حد أقصى ثلاث فرص عبر ١٠ و١١ و١٢ ديسمبر. حجم المجموعة لا يمنح فرصًا إضافية — يحتاج كل شخص إلى تسجيل زائر مستقل. يُعلَن عن الفائزين يوم السبت ١٢ ديسمبر ٢٠٢٦.",
    drawDraftLegalGate: "لا يُنشر إلا بعد: اعتماد قائمة الجوائز، وإقرار الشروط والأهلية، والحصول على أي ترخيص لازم للمنافسات التجارية من وزارة التجارة السعودية (mc.gov.sa/ar/mediacenter/News/Pages/21-09-25-01.aspx و/10-09-24-01.aspx).",
    drawDraftBlurb: "احتفظ برقم تسجيلك. كل يوم تحضر فيه ويُؤكَّد حضورك يمنح رقمك فرصة إضافية في السحب على الجوائز، بحد أقصى ثلاث فرص. نعلن الفائزين يوم السبت ١٢ ديسمبر.",
    drawDraftFormNote: "نص مسوّدة لنموذج التسجيل (لا يُنشر): تعال في أي يوم من ١٠–١٢ ديسمبر ودع الطاقم يُسجّل حضورك لتحصل على فرصة في جائزة الحضور اليومي. فرصة واحدة في اليوم، حتى ثلاث فرص خلال الفعالية. الشروط الكاملة ستُنشر قبل الفعالية.",
    drawDraftConfirmationNote: "نص مسوّدة لبريد التأكيد (لا يُنشر): سنحسب زياراتك يومًا بيوم. حضورك في أيام أكثر يمنحك فرصًا أكثر في جائزة الحضور اليومي. يبقى تسجيل المجموعة برقم واحد — من أراد فرصه الخاصة عليه التسجيل مستقلًّا.",
    drawDraftReminderNote: "نص مسوّدة لتذكير واحد قبل الفعالية — مُقترح لا مُجدوَل. لم يأذن المالك بالإرسال، ولم يُدَقَّق تسليم البريد بعد. النص المقترح: «تبدأ الفعالية غدًا. كل يوم تحضر فيه ويُؤكِّد الطاقم تسجيل حضورك يمنحك فرصة إضافية في السحب، بحد أقصى ثلاث فرص. نعلن الفائزين يوم السبت ١٢ ديسمبر.»",
    drawDraftDaysHelper: "اختيار الأيام هنا للتخطيط فقط. تُحتسب فرصة إضافية في السحب عن كل يوم تحضر فيه وتُسجّل حضورك في الموقع.",
    drawDraftRuleset: "زوار اليوم الأول مؤهّلون للسحب النهائي حتى دون حضور اليوم الثالث. حجم المجموعة لا يمنح فرصًا إضافية لمرافقين غير مسجَّلين. حد أقصى فرصة واحدة لكل شخص مؤكَّد الحضور في اليوم. الحد الأقصى للزائر خلال ثلاثة أيام: ثلاث فرص. يجب الإفصاح عن تفاصيل الجوائز وشروط السحب مسبقًا وتأكيد الترخيص.",
    // Rev 7.6 draft eligibility (admin preview only)
    drawDraftEligibilityEN: "Ticket-level entry only. The lead registrant (name + mobile on file) is the sole prize claimant. Accompanying persons do not receive individual tickets, draw entries, or independent prize claims. At most one verified check-in entry per group ticket per day, up to three across December 10–12.",
    drawDraftEligibilityAR: "المشاركة على مستوى التذكرة فقط. صاحب التذكرة (الاسم والجوّال المسجَّلان) هو الوحيد المخوَّل باستلام الجائزة. لا يحصل المرافقون على تذاكر أو فرص أو مطالبات مستقلة. الحد الأقصى تسجيل حضور مؤكَّد واحد لكل تذكرة مجموعة في اليوم، وبحدٍ أقصى ثلاث فرص خلال ١٠–١٢ ديسمبر.",

    // ---- Visitor confirmation — AR ----
    visitorTyTitle: "تم تسجيلك بنجاح.",
    visitorTyRefLabel: "رقم تسجيلك كزائر",
    visitorTyRefHelper: "احتفظ برقم زائرك. قد يطلبه الطاقم عند الوصول.",
    visitorTyCopy: "نسخ رقم الزائر",
    visitorTyCopied: "تم النسخ",
    visitorTyCopyFailed: "تعذّر النسخ — اضغط مطوّلًا على الرقم لنسخه.",
    visitorTyEmailReassure: "انسخ رقم تسجيلك أو احتفظ بلقطة شاشة له لتجده بسهولة عند الحضور.",
    visitorTyBody: "شكرًا لتسجيلك كزائر في فعالية THE GATHERING — شتاء ٢٠٢٦. احتفظ برقم تسجيلك أدناه — فهو سجل التذكرة الوحيد لمجموعتك.",
    visitorTyDupNote: "أنت مسجَّل مسبقًا بهذا الرقم — لن نُنشئ سجلًّا مكرَّرًا.",
    visitorTyHome: "العودة إلى الصفحة الرئيسية",

    // ---- Admin visitor panel — AR ----
    adminVisitorsTitle: "تسجيلات الزوار",
    adminVisitorsSearch: "ابحث برقم التسجيل أو الاسم أو البريد أو الجوال",
    adminVisitorsDayAll: "كل الأيام",
    adminVisitorsRegistrations: "التسجيلات",
    adminVisitorsPlannedHead: "إجمالي عدد الحضور المخطَّط (كل المجموعات)",
    adminVisitorsPlannedByDay: "الحضور المخطَّط حسب اليوم",
    adminVisitorsVerifiedByDay: "الحضور المؤكَّد ميدانيًا حسب اليوم",
    adminVisitorsExportCsv: "تصدير CSV",
    adminVisitorsCheckinDec10: "تسجيل حضور · ١٠ ديسمبر",
    adminVisitorsCheckinDec11: "تسجيل حضور · ١١ ديسمبر",
    adminVisitorsCheckinDec12: "تسجيل حضور · ١٢ ديسمبر",
    adminVisitorsCheckedIn: "تم تسجيل الحضور",
    adminVisitorsCheckinConfirm: "تأكيد تسجيل حضور {name} في {day} ميدانيًا؟ لا يمكن التراجع عن هذا الإجراء من الواجهة.",
    adminVisitorsNoRows: "لا توجد تسجيلات زوار تطابق هذا التصفية بعد.",
  },
};

export const LANG_KEY = "crewznation_lang";
